export default {
	USING_PRODUCTION_SERVER: 'Note that you are using production api!',
	USING_DEVELOPMENT_SERVER: 'Using test api',
	VACATION_TOOLTIP: 'Click to view and log a new vacation',
	VACATION_BUTTON: 'Vacation',
	PARTNERSHIP_BUTTON: 'JoeApp Benefits',
};
